export default __webpack_public_path__ + "static/media/medicare-yellow-guided.47a09899.png";